import React, { useState } from "react";
import logo from "./images/ts-logo-nobg.png";
import logoClosed from "./images/logo-closed.png";
import "./styles/App.scss";
import {
  Route,
  BrowserRouter,
  Routes,
  NavLink,
  Navigate,
  useParams,
} from "react-router-dom";
import MarinerProfileComponent from "./components/marinerProfile/MarinerProfileComponent";
import MarinerListComponent from "./components/marinerList/MarinerListComponent";
import { Avatar, Button, ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  logout,
  selectCurrentCaptain,
  selectCurrentTrainingAssistant,
  selectCurrentProfile,
} from "./redux/authentication/authSlice";
import "react-toastify/dist/ReactToastify.min.css";
import { CssBaseline } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import Tooltip from "@mui/material/Tooltip";
import theme from "./styles/theme";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import ContentPasteRoundedIcon from "@mui/icons-material/ContentPasteRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import WorkRoundedIcon from "@mui/icons-material/WorkRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardDoubleArrowRightRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowRightRounded";
import KeyboardDoubleArrowLeftRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftRounded";
import KeyboardDoubleArrowUpRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowUpRounded";
import DirectionsBoatFilledRoundedIcon from "@mui/icons-material/DirectionsBoatFilledRounded";
import VesselRosterComponent from "./components/vesselRosterManagement/VesselRosterComponent";
import JobOrderForm from "./components/jobOrder/JobOrderForm";
import JobOrderListComponent from "./components/JobOrderListComponent";
import JobBoardListComponent from "./components/jobBoard/JobBoardListComponent";
import JobBoardPostingComponent from "./components/jobBoard/JobBoardPostingComponent";
import Vessels from "./components/vessel/Vessels";
import Home from "./components/home/Home";
import RequireAuth from "./redux/authentication/RequireAuth";
import { UserGroup } from "./common/User";
import { selectCurrentUser } from "./redux/authentication/authSlice";
import { colorFromName } from "./common/ColorFromName";
import CognitoUserForm from "./components/profileMissing/CognitoUserForm";
import Landing from "./components/registration/Landing";
import TrainingRosterComponent from "./components/training/TrainingRosterComponent";
import ComplianceTrainingRosterComponent from "./components/training/ComplianceTrainingRosterComponent";
import {
  Dvr,
  DesktopWindows,
  AdminPanelSettings,
  DisplaySettings,
  DesktopWindowsOutlined,
  AssignmentInd,
  AssignmentTurnedIn,
  FactCheck,
} from "@mui/icons-material";
import TrainingOrderListComponent from "./components/training/TrainingOrderListComponent";
import DuplicateJobOrders from "./components/admin/DuplicateJobOrders";
import TrainingInsights from "./components/training/TrainingInsights";
import TrainingOrderForm from "./components/training/TrainingOrderForm";
import AdminPage from "./components/admin/AdminPage";
import EvaluationRouter from "./components/evaluation/EvaluationRouter";
import AdminStatsPage from "./components/admin/AdminStatsPage";
import EvaluationInsights from "./components/evaluation/EvaluationInsights";
import MarinerEvaluationInsights from "./components/evaluation/MarinerEvaluationInsights";
import EvaluationArchive from "./components/evaluation/EvaluationArchive";
// import Banner from "./components/Banner";

function App() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const user = useSelector(selectCurrentUser);
  const userGroup = user?.userGroup as UserGroup;
  const userProfile = useSelector(selectCurrentProfile);
  const isCaptain = useSelector(selectCurrentCaptain);
  const isTrainingAssistant = useSelector(selectCurrentTrainingAssistant);

  const getList = () => (
    <div
      className={mobileOpen ? "drawer-mobile " : "drawer"}
      onClick={() => (mobileOpen ? setMobileOpen(false) : setOpen(false))}
    >
      <NavLink to="/" className="top-navheader">
        <img src={logo} alt="tote services logo" />
      </NavLink>
      <ul>
        {userGroup !== UserGroup.MARINERS && (
          <li>
            <NavLink
              to="/vessels"
              end
              className={({ isActive }) => (isActive ? "link-active" : "link")}
            >
              <DirectionsBoatFilledRoundedIcon />
              Vessels
            </NavLink>
          </li>
        )}
        {userGroup === UserGroup.MARINERS && (
          <li>
            <NavLink
              to="/home"
              end
              className={({ isActive }) => (isActive ? "link-active" : "link")}
            >
              <HomeRoundedIcon />
              Home
            </NavLink>
          </li>
        )}
        {userGroup !== UserGroup.MARINERS && (
          <li>
            <NavLink
              to="/jobOrders"
              className={({ isActive }) => (isActive ? "link-active" : "link")}
            >
              <SwapHorizRoundedIcon className="swap-icon" />
              Job Orders
            </NavLink>
          </li>
        )}
        {(userGroup !== UserGroup.MARINERS || isCaptain) && (
          <li>
            <NavLink
              to="/roster/"
              className={({ isActive }) => (isActive ? "link-active" : "link")}
            >
              <ContentPasteRoundedIcon />
              Rosters
            </NavLink>
          </li>
        )}
        {userGroup !== UserGroup.MARINERS && (
          <li>
            <NavLink
              to="/profiles"
              className={({ isActive }) => (isActive ? "link-active" : "link")}
            >
              <PeopleRoundedIcon />
              Mariners
            </NavLink>
          </li>
        )}
        {(userGroup === UserGroup.HUMAN_RESOURCES ||
          userGroup === UserGroup.HUMAN_RESOURCES_ADMINS) && (
          <li>
            <NavLink
              to={`/adminStats`}
              className={({ isActive }) => (isActive ? "link-active" : "link")}
            >
              <AdminPanelSettings />
              {userGroup === UserGroup.HUMAN_RESOURCES_ADMINS
                ? "HR Admin Page"
                : "Admin Page"}
            </NavLink>
          </li>
        )}
        {userGroup === UserGroup.MARINERS && (
          <li>
            <NavLink
              to={`/profiles/${userProfile?.id}`}
              className={({ isActive }) => (isActive ? "link-active" : "link")}
            >
              <PersonRoundedIcon />
              Profile
            </NavLink>
          </li>
        )}
        {(userGroup === UserGroup.CREWING_MANAGERS ||
          userGroup === UserGroup.HUMAN_RESOURCES_ADMINS) && (
          <>
            <li>
              <NavLink
                to={`/admin`}
                className={({ isActive }) =>
                  isActive ? "link-active" : "link"
                }
              >
                <AdminPanelSettings />
                {userGroup === UserGroup.HUMAN_RESOURCES_ADMINS
                  ? "Crewing Manager Admin Page"
                  : "Admin Page"}
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`/duplicates`}
                className={({ isActive }) =>
                  isActive ? "link-active" : "link"
                }
              >
                <p className="icon-copy-delete ft-24" />
                Duplicate Job Orders
              </NavLink>
            </li>
          </>
        )}
        <li>
          <NavLink
            to="/jobBoard"
            className={({ isActive }) => (isActive ? "link-active" : "link")}
          >
            <WorkRoundedIcon />
            Job Board
          </NavLink>
        </li>
        {(userGroup === UserGroup.CREWING_SPECIALISTS ||
          userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
          userGroup === UserGroup.CREWING_MANAGERS ||
          userGroup === UserGroup.HUMAN_RESOURCES_ADMINS ||
          userGroup === UserGroup.CREWING_EXECS ||
          userGroup === UserGroup.FLEET_EXECS ||
          userGroup === UserGroup.VESSEL_EXECS) && (
          <>
            <li>
              <NavLink
                to="/trainingInsights"
                className={({ isActive }) =>
                  isActive ? "link-active" : "link"
                }
              >
                <WorkRoundedIcon />
                Training Insights
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`/trainingOrders`}
                className={({ isActive }) =>
                  isActive ? "link-active" : "link"
                }
              >
                <DisplaySettings />
                Training Orders
              </NavLink>
            </li>
          </>
        )}
        {(userGroup === UserGroup.CREWING_SPECIALISTS ||
          userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
          userGroup === UserGroup.CREWING_MANAGERS ||
          userGroup === UserGroup.CREWING_EXECS ||
          userGroup === UserGroup.FLEET_EXECS ||
          userGroup === UserGroup.VESSEL_EXECS ||
          userGroup === UserGroup.HUMAN_RESOURCES_ADMINS ||
          isCaptain ||
          isTrainingAssistant) && (
          <>
            <li>
              <NavLink
                to={`/trainingRoster`}
                className={({ isActive }) =>
                  isActive ? "link-active" : "link"
                }
              >
                <Dvr />
                Training Roster
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`/complianceRoster`}
                className={({ isActive }) =>
                  isActive ? "link-active" : "link"
                }
              >
                <FactCheck />
                Compliance Training Roster
              </NavLink>
            </li>
          </>
        )}
        {(userGroup === UserGroup.HUMAN_RESOURCES ||
          userGroup === UserGroup.HUMAN_RESOURCES_ADMINS ||
          userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
          userGroup === UserGroup.CREWING_MANAGERS ||
          userGroup === UserGroup.CREWING_EXECS ||
          userGroup === UserGroup.FLEET_EXECS ||
          userGroup === UserGroup.VESSEL_EXECS ||
          (userGroup === UserGroup.MARINERS)) && (
          <li>
            <NavLink
              to={`/evaluations`}
              className={({ isActive }) => (isActive ? "link-active" : "link")}
            >
              <AssignmentInd />
              {userGroup === UserGroup.HUMAN_RESOURCES ||
              userGroup === UserGroup.HUMAN_RESOURCES_ADMINS ||
              userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
              userGroup === UserGroup.CREWING_MANAGERS
                ? "Performance Evaluation Insights"
                : "Performance Evaluations"}
            </NavLink>
          </li>
        )}
        {(userGroup === UserGroup.HUMAN_RESOURCES ||
          userGroup === UserGroup.HUMAN_RESOURCES_ADMINS ||
          userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
          userGroup === UserGroup.CREWING_MANAGERS ||
          userGroup === UserGroup.FLEET_EXECS ||
          userGroup === UserGroup.VESSEL_EXECS ||
          isCaptain) && (
          <li>
            <NavLink
              to={`/evaluationArchives`}
              className={({ isActive }) => (isActive ? "link-active" : "link")}
            >
              <AssignmentTurnedIn />
              Performance Evaluation Archives
            </NavLink>
          </li>
        )}
        <li className="disabled-link">
          <NavLink
            to="/"
            // className={({ isActive }) => (isActive ? "link-active" : "link")}
          >
            <SettingsRoundedIcon />
            Settings
          </NavLink>
        </li>
        <li>
          <Button
            className="logout-link open"
            onClick={() => {
              const exit = window.confirm("Are you sure you want to logout?");
              if (exit) {
                dispatch(logout(null));
              }
            }}
          >
            <LogoutRoundedIcon />
            Logout
          </Button>
        </li>
      </ul>
      <div className="nav-lower-wrap">
        <ul className="nav-lower">
          <li className="user-link">
            <span className="user-label">Current User</span>
            <NavLink
              to="/"
              // className={({ isActive }) => (isActive ? "link-active" : "link")}
            >
              <Avatar
                sx={{
                  bgcolor: user ? colorFromName(user.name) : colorFromName(""),
                  height: 24,
                  width: 24,
                  fontSize: 16,
                }}
                alt={user ? user.name : ""}
                src="/"
              ></Avatar>
              {user ? user.name : ""}
            </NavLink>
          </li>
        </ul>
        <Button
          className="nav-button"
          onClick={() => (mobileOpen ? setMobileOpen(false) : setOpen(true))}
        >
          {mobileOpen ? (
            <KeyboardDoubleArrowUpRoundedIcon />
          ) : (
            <KeyboardDoubleArrowLeftRoundedIcon />
          )}
        </Button>
      </div>
    </div>
  );

  const getLandingPage = (isCaptain: boolean, userGroup: UserGroup) => {
    if (
      userGroup === UserGroup.CREWING_EXECS ||
      userGroup === UserGroup.FLEET_EXECS ||
      userGroup === UserGroup.VESSEL_EXECS ||
      userGroup === UserGroup.HUMAN_RESOURCES ||
      userGroup === UserGroup.HUMAN_RESOURCES_ADMINS
    ) {
      return <Navigate to="/vessels" />;
    }
    if (
      userGroup === UserGroup.CREWING_SPECIALISTS ||
      userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
      userGroup === UserGroup.CREWING_MANAGERS
    ) {
      return <Navigate to="/jobOrders" />;
    }
    if (userGroup === UserGroup.MARINERS) {
      return !!isCaptain ? <Navigate to="/roster" /> : <Navigate to="/home" />;
    }
    return <></>;
  };

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <CssBaseline enableColorScheme />
        <div className="app">
          {/* banner functionality */}
          {/* {userGroup === UserGroup.MARINERS && <Banner />} */}
          {!!userGroup && (
            <>
              <nav>
                <NavLink to="/" className="top-navheader">
                  <img src={logoClosed} alt="tote services logo" />
                </NavLink>
                <ul>
                  {userGroup !== UserGroup.MARINERS && (
                    <Tooltip title="Vessels" placement="right">
                      <li>
                        <NavLink
                          to="/vessels"
                          end
                          className={({ isActive }) =>
                            isActive ? "link-active" : "link"
                          }
                        >
                          <DirectionsBoatFilledRoundedIcon />
                        </NavLink>
                      </li>
                    </Tooltip>
                  )}
                  {userGroup === UserGroup.MARINERS && (
                    <Tooltip title="Home" placement="right">
                      <li>
                        <NavLink
                          to="/home"
                          end
                          className={({ isActive }) =>
                            isActive ? "link-active" : "link"
                          }
                        >
                          <HomeRoundedIcon />
                        </NavLink>
                      </li>
                    </Tooltip>
                  )}
                  {userGroup !== UserGroup.MARINERS && (
                    <Tooltip title="Job Orders" placement="right">
                      <li>
                        <NavLink
                          to="/jobOrders"
                          className={({ isActive }) =>
                            isActive ? "link-active" : "link"
                          }
                        >
                          <SwapHorizRoundedIcon className="swap-icon" />
                        </NavLink>
                      </li>
                    </Tooltip>
                  )}
                  {(userGroup !== UserGroup.MARINERS || isCaptain) && (
                    <Tooltip title="Rosters" placement="right">
                      <li>
                        <NavLink
                          to="/roster/"
                          className={({ isActive }) =>
                            isActive ? "link-active" : "link"
                          }
                        >
                          <ContentPasteRoundedIcon />
                        </NavLink>
                      </li>
                    </Tooltip>
                  )}
                  {userGroup !== UserGroup.MARINERS && (
                    <Tooltip title="Mariners" placement="right">
                      <li>
                        <NavLink
                          to="/profiles"
                          className={({ isActive }) =>
                            isActive ? "link-active" : "link"
                          }
                        >
                          <PeopleRoundedIcon />
                        </NavLink>
                      </li>
                    </Tooltip>
                  )}
                  {(userGroup === UserGroup.HUMAN_RESOURCES ||
                    userGroup === UserGroup.HUMAN_RESOURCES_ADMINS) && (
                    <Tooltip
                      title={
                        userGroup === UserGroup.HUMAN_RESOURCES_ADMINS
                          ? "HR Admin Page"
                          : "Admin Page"
                      }
                      placement="right"
                    >
                      <li>
                        <NavLink
                          to={`/adminStats`}
                          className={({ isActive }) =>
                            isActive ? "link-active" : "link"
                          }
                        >
                          <AdminPanelSettings />
                        </NavLink>
                      </li>
                    </Tooltip>
                  )}
                  {userGroup === UserGroup.MARINERS && (
                    <Tooltip title="Profile" placement="right">
                      <li>
                        <NavLink
                          to={`/profiles/${userProfile?.id}`}
                          className={({ isActive }) =>
                            isActive ? "link-active" : "link"
                          }
                        >
                          <PersonRoundedIcon />
                        </NavLink>
                      </li>
                    </Tooltip>
                  )}
                  {(userGroup === UserGroup.CREWING_MANAGERS ||
                    userGroup === UserGroup.HUMAN_RESOURCES_ADMINS) && (
                    <>
                      <Tooltip
                        title={
                          userGroup === UserGroup.HUMAN_RESOURCES_ADMINS
                            ? "Crewing Manager Admin Page"
                            : "Admin Page"
                        }
                        placement="right"
                      >
                        <li>
                          <NavLink
                            to={`/admin`}
                            className={({ isActive }) =>
                              isActive ? "link-active" : "link"
                            }
                          >
                            <AdminPanelSettings />
                          </NavLink>
                        </li>
                      </Tooltip>
                      <Tooltip title="Duplicate Job Orders" placement="right">
                        <li>
                          <NavLink
                            to={`/duplicates`}
                            className={({ isActive }) =>
                              isActive ? "link-active" : "link"
                            }
                          >
                            <p className="icon-copy-delete ft-24" />
                          </NavLink>
                        </li>
                      </Tooltip>
                    </>
                  )}
                  {userGroup !== UserGroup.FLEET_EXECS &&
                    userGroup !== UserGroup.VESSEL_EXECS && (
                      <Tooltip title="Job Board" placement="right">
                        <li>
                          <NavLink
                            to="/jobBoard"
                            className={({ isActive }) =>
                              isActive ? "link-active" : "link"
                            }
                          >
                            <WorkRoundedIcon />
                          </NavLink>
                        </li>
                      </Tooltip>
                    )}
                  {(userGroup === UserGroup.CREWING_EXECS ||
                    userGroup === UserGroup.CREWING_MANAGERS ||
                    userGroup === UserGroup.HUMAN_RESOURCES_ADMINS ||
                    userGroup === UserGroup.CREWING_SPECIALISTS ||
                    userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
                    userGroup === UserGroup.FLEET_EXECS ||
                    userGroup === UserGroup.VESSEL_EXECS) && (
                    <>
                      <Tooltip title="Training Insights" placement="right">
                        <li>
                          <NavLink
                            to="/trainingInsights"
                            className={({ isActive }) =>
                              isActive ? "link-active" : "link"
                            }
                          >
                            <DesktopWindows />
                          </NavLink>
                        </li>
                      </Tooltip>
                      <Tooltip title="Training Orders" placement="right">
                        <li>
                          <NavLink
                            to="/trainingOrders"
                            className={({ isActive }) =>
                              isActive ? "link-active" : "link"
                            }
                          >
                            <DisplaySettings />
                          </NavLink>
                        </li>
                      </Tooltip>
                    </>
                  )}
                  {(userGroup === UserGroup.CREWING_EXECS ||
                    userGroup === UserGroup.CREWING_MANAGERS ||
                    userGroup === UserGroup.CREWING_SPECIALISTS ||
                    userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
                    userGroup === UserGroup.FLEET_EXECS ||
                    userGroup === UserGroup.VESSEL_EXECS ||
                    userGroup === UserGroup.HUMAN_RESOURCES_ADMINS ||
                    isCaptain ||
                    isTrainingAssistant) && (
                    <>
                      <Tooltip title="Training Roster" placement="right">
                        <li>
                          <NavLink
                            to={`/trainingRoster`}
                            className={({ isActive }) =>
                              isActive ? "link-active" : "link"
                            }
                          >
                            <DesktopWindowsOutlined />
                          </NavLink>
                        </li>
                      </Tooltip>
                      <Tooltip title="Compliance Training Roster" placement="right">
                        <li>
                          <NavLink
                            to={`/complianceRoster`}
                            className={({ isActive }) =>
                              isActive ? "link-active" : "link"
                            }
                          >
                            <FactCheck />
                          </NavLink>
                        </li>
                      </Tooltip>
                    </>
                  )}
                  {(userGroup === UserGroup.HUMAN_RESOURCES ||
                    userGroup === UserGroup.HUMAN_RESOURCES_ADMINS ||
                    userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
                    userGroup === UserGroup.CREWING_MANAGERS ||
                    userGroup === UserGroup.CREWING_EXECS ||
                    userGroup === UserGroup.FLEET_EXECS ||
                    userGroup === UserGroup.VESSEL_EXECS ||
                    (userGroup === UserGroup.MARINERS)) && (
                    <Tooltip
                      title={
                        userGroup === UserGroup.HUMAN_RESOURCES ||
                        userGroup === UserGroup.HUMAN_RESOURCES_ADMINS ||
                        userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
                        userGroup === UserGroup.CREWING_MANAGERS
                          ? "Performance Evaluation Insights"
                          : "Performance Evaluations"
                      }
                      placement="right"
                    >
                      <li>
                        <NavLink
                          to={`/evaluations`}
                          className={({ isActive }) =>
                            isActive ? "link-active" : "link"
                          }
                        >
                          <AssignmentInd />
                        </NavLink>
                      </li>
                    </Tooltip>
                  )}
                  {(userGroup === UserGroup.HUMAN_RESOURCES ||
                    userGroup === UserGroup.HUMAN_RESOURCES_ADMINS ||
                    userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
                    userGroup === UserGroup.CREWING_MANAGERS ||
                    userGroup === UserGroup.FLEET_EXECS ||
                    userGroup === UserGroup.VESSEL_EXECS ||
                    isCaptain) && (
                    <>
                      <Tooltip
                        title="Performance Evaluation Archives"
                        placement="right"
                      >
                        <li>
                          <NavLink
                            to={`/evaluationArchives`}
                            className={({ isActive }) =>
                              isActive ? "link-active" : "link"
                            }
                          >
                            <AssignmentTurnedIn />
                          </NavLink>
                        </li>
                      </Tooltip>
                    </>
                  )}
                  <Tooltip title="Settings" placement="right">
                    <li className="disabled-link">
                      <NavLink
                        to="/"
                        // className={({ isActive }) =>
                        //   isActive ? "link-active" : "link"
                        // }
                      >
                        <SettingsRoundedIcon />
                      </NavLink>
                    </li>
                  </Tooltip>
                  <Tooltip title={user ? "Logout" : "Login"} placement="right">
                    <li>
                      <Button
                        className="logout-link"
                        onClick={() => {
                          if (user) {
                            const exit = window.confirm(
                              "Are you sure you want to logout?"
                            );
                            if (exit) {
                              dispatch(logout(null));
                            }
                          } else {
                            window.location.replace(
                              `${process.env.REACT_APP_COGNITO_DOMAIN}login?client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&response_type=code&scope=openid&redirect_uri=${process.env.REACT_APP_COGNITO_REDIRECT_URI}`
                            );
                          }
                        }}
                      >
                        {/* TODO: Add a Login icon */}
                        <LogoutRoundedIcon />
                      </Button>
                    </li>
                  </Tooltip>
                </ul>
                <div className="nav-lower-wrap">
                  <ul className="nav-lower">
                    <Tooltip title={user ? user.name : ""} placement="right">
                      <li>
                        <NavLink
                          to="/"
                          // className={({ isActive }) => (isActive ? "link-active" : "link")}
                        >
                          <Avatar
                            sx={{
                              bgcolor: user
                                ? colorFromName(user.name)
                                : colorFromName(""),
                              height: 24,
                              width: 24,
                              fontSize: 16,
                            }}
                            alt={user ? user.name : ""}
                            src="/"
                          />
                        </NavLink>
                      </li>
                    </Tooltip>
                  </ul>
                  <Tooltip title="Open Navigation" placement="right">
                    <Button
                      className="nav-button"
                      onClick={() => setOpen(true)}
                    >
                      <KeyboardDoubleArrowRightRoundedIcon />
                    </Button>
                  </Tooltip>
                </div>
                <Drawer
                  open={open}
                  anchor={"left"}
                  onClose={() => setOpen(false)}
                  ModalProps={{
                    keepMounted: true,
                  }}
                >
                  {getList()}
                </Drawer>
              </nav>
              {/* New Mobile Navigation */}
              <div className="mobile-nav">
                <NavLink to="/">
                  <img src={logoClosed} alt="tote services logo" />
                </NavLink>
                <MenuIcon onClick={() => setMobileOpen(true)} />
              </div>
              <Drawer
                open={mobileOpen}
                anchor={"top"}
                onClose={() => setMobileOpen(false)}
                ModalProps={{
                  keepMounted: true,
                }}
              >
                {getList()}
              </Drawer>
            </>
          )}
          <div className="content">
            <Routes>
              {/* protected routes */}
              <Route
                element={
                  <RequireAuth
                    allowedUserGroups={[
                      UserGroup.MARINERS,
                      UserGroup.CREWING_SPECIALISTS,
                      UserGroup.CREWING_EVAL_SPECIALISTS,
                      UserGroup.CREWING_MANAGERS,
                      UserGroup.CREWING_EXECS,
                      UserGroup.HUMAN_RESOURCES,
                      UserGroup.HUMAN_RESOURCES_ADMINS,
                      UserGroup.FLEET_EXECS,
                      UserGroup.VESSEL_EXECS,
                    ]}
                  />
                }
              >
                <Route path="/profiles" element={<MarinerListComponent />} />
                <Route path="/jobBoard" element={<JobBoardListComponent />} />
                <Route
                  path="/jobBoard/:id"
                  element={<JobBoardPostingComponent />}
                />
              </Route>
              {isCaptain && (
                <Route
                  element={
                    <RequireAuth allowedUserGroups={[UserGroup.MARINERS]} />
                  }
                >
                  <Route path="/roster/" element={<VesselRosterComponent />} />
                  <Route
                    path="/roster/:id"
                    element={<VesselRosterComponent />}
                  />
                </Route>
              )}
              {!isCaptain && (
                <Route
                  element={
                    <RequireAuth
                      allowedUserGroups={[
                        UserGroup.CREWING_SPECIALISTS,
                        UserGroup.CREWING_EVAL_SPECIALISTS,
                        UserGroup.CREWING_MANAGERS,
                        UserGroup.CREWING_EXECS,
                        UserGroup.FLEET_EXECS,
                        UserGroup.HUMAN_RESOURCES,
                        UserGroup.HUMAN_RESOURCES_ADMINS,
                        UserGroup.VESSEL_EXECS,
                      ]}
                    />
                  }
                >
                  <Route path="/roster/" element={<VesselRosterComponent />} />
                  <Route
                    path="/roster/:id"
                    element={<VesselRosterComponent />}
                  />
                </Route>
              )}
              <Route
                element={
                  <RequireAuth
                    allowedUserGroups={[
                      UserGroup.MARINERS,
                      UserGroup.CREWING_SPECIALISTS,
                      UserGroup.CREWING_EVAL_SPECIALISTS,
                      UserGroup.CREWING_MANAGERS,
                      UserGroup.HUMAN_RESOURCES,
                      UserGroup.HUMAN_RESOURCES_ADMINS,
                    ]}
                  />
                }
              >
                <Route
                  path="/profiles/:id"
                  element={<MarinerProfileComponent />}
                />
              </Route>
              <Route
                element={
                  <RequireAuth
                    allowedUserGroups={[
                      UserGroup.CREWING_SPECIALISTS,
                      UserGroup.CREWING_EVAL_SPECIALISTS,
                      UserGroup.CREWING_MANAGERS,
                      UserGroup.CREWING_EXECS,
                      UserGroup.FLEET_EXECS,
                      UserGroup.VESSEL_EXECS,
                      UserGroup.HUMAN_RESOURCES,
                      UserGroup.HUMAN_RESOURCES_ADMINS,
                    ]}
                  />
                }
              >
                <Route path="/vessels" element={<Vessels />} />
              </Route>
              <Route
                element={
                  <RequireAuth
                    allowedUserGroups={[
                      UserGroup.CREWING_SPECIALISTS,
                      UserGroup.CREWING_EVAL_SPECIALISTS,
                      UserGroup.CREWING_MANAGERS,
                      UserGroup.CREWING_EXECS,
                      UserGroup.HUMAN_RESOURCES,
                      UserGroup.HUMAN_RESOURCES_ADMINS,
                      UserGroup.FLEET_EXECS,
                      UserGroup.VESSEL_EXECS,
                    ]}
                  />
                }
              >
                <Route path="/jobOrders" element={<JobOrderListComponent />} />
                <Route path="/jobOrders/:id" element={<JobOrderForm />} />
              </Route>

              <Route
                element={
                  <RequireAuth allowedUserGroups={[UserGroup.MARINERS]} />
                }
              >
                <Route path="/home" element={<Home />} />
              </Route>

              <Route
                element={
                  <RequireAuth
                    allowedUserGroups={[
                      UserGroup.MARINERS,
                      UserGroup.CREWING_SPECIALISTS,
                      UserGroup.CREWING_EVAL_SPECIALISTS,
                      UserGroup.CREWING_MANAGERS,
                      UserGroup.CREWING_EXECS,
                      UserGroup.FLEET_EXECS,
                      UserGroup.HUMAN_RESOURCES,
                      UserGroup.HUMAN_RESOURCES_ADMINS,
                      UserGroup.VESSEL_EXECS,
                    ]}
                  />
                }
              >
                <Route
                  path="/"
                  element={getLandingPage(isCaptain, userGroup)}
                />
                <Route path="/user" element={<CognitoUserForm />} />
                <Route path="/evaluation/:id" element={<EvaluationRedirect/>} />
                <Route path="/evaluations/:id" element={<EvaluationRouter />} />
              </Route>
              <Route
                element={
                  <RequireAuth
                    allowedUserGroups={[
                      UserGroup.CREWING_MANAGERS,
                      UserGroup.HUMAN_RESOURCES_ADMINS,
                    ]}
                  />
                }
              >
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/duplicates" element={<DuplicateJobOrders />} />
              </Route>
              {!isCaptain && !isTrainingAssistant && (
                <Route
                  element={
                    <RequireAuth
                      allowedUserGroups={[
                        UserGroup.CREWING_MANAGERS,
                        UserGroup.CREWING_SPECIALISTS,
                        UserGroup.CREWING_EVAL_SPECIALISTS,
                        UserGroup.CREWING_EXECS,
                        UserGroup.FLEET_EXECS,
                        UserGroup.VESSEL_EXECS,
                        UserGroup.HUMAN_RESOURCES_ADMINS,
                      ]}
                    />
                  }
                >
                  <Route
                    path="/trainingInsights"
                    element={<TrainingInsights />}
                  />
                  <Route
                    path="/trainingOrders"
                    element={<TrainingOrderListComponent />}
                  />
                  <Route
                    path="/trainingOrders/:id"
                    element={<TrainingOrderForm />}
                  />
                  <Route
                    path="/trainingRoster"
                    element={<TrainingRosterComponent />}
                  />
                  <Route
                    path="/trainingRoster/:id"
                    element={<TrainingRosterComponent />}
                  />
                  <Route
                    path="/complianceRoster"
                    element={<ComplianceTrainingRosterComponent />}
                  />
                  <Route
                    path="/complianceRoster/:id"
                    element={<ComplianceTrainingRosterComponent />}
                  />
                </Route>
              )}
              {(isCaptain || isTrainingAssistant) && (
                <Route
                  element={
                    <RequireAuth allowedUserGroups={[UserGroup.MARINERS]} />
                  }
                >
                  <Route
                    path="/trainingRoster"
                    element={<TrainingRosterComponent />}
                  />
                  <Route
                    path="/trainingRoster/:id"
                    element={<TrainingRosterComponent />}
                  />
                  <Route
                    path="/complianceRoster"
                    element={<ComplianceTrainingRosterComponent />}
                  />
                  <Route
                    path="/complianceRoster/:id"
                    element={<ComplianceTrainingRosterComponent />}
                  />
                </Route>
              )}
              <Route
                element={
                  <RequireAuth
                    allowedUserGroups={[
                      UserGroup.HUMAN_RESOURCES,
                      UserGroup.HUMAN_RESOURCES_ADMINS,
                      UserGroup.CREWING_EVAL_SPECIALISTS,
                      UserGroup.CREWING_MANAGERS,
                      UserGroup.CREWING_EXECS,
                      UserGroup.FLEET_EXECS,
                      UserGroup.VESSEL_EXECS,
                      UserGroup.MARINERS,
                    ]}
                  />
                }
              >
                <Route
                  path="/evaluations"
                  element={
                    userGroup === UserGroup.HUMAN_RESOURCES ||
                    userGroup === UserGroup.HUMAN_RESOURCES_ADMINS ||
                    userGroup === UserGroup.CREWING_EVAL_SPECIALISTS ||
                    userGroup === UserGroup.CREWING_MANAGERS ? (
                      <EvaluationInsights />
                    ) : (
                      <MarinerEvaluationInsights />
                    )
                  }
                />
                <Route
                  path="/evaluationArchives"
                  element={<EvaluationArchive />}
                />
                <Route path="/adminStats" element={<AdminStatsPage />} />
              </Route>
              <Route path="/landing" element={<Landing />} />
            </Routes>
          </div>
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
}

const EvaluationRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/evaluations/${id}`} replace />;
};

export default App;
